import { AppState, RouteStatus } from '@news-mono/web-common'
import React from 'react'
import { connect, DispatchProp } from 'react-redux'
import { Redirect } from 'react-router'

export type RedirectPathDeterminer = (props: Partial<RedirectorProps>) => string

export interface OwnProps {
    getRedirectPathFromState: RedirectPathDeterminer
    status?: number
}

export type RedirectorProps = OwnProps & AppState & DispatchProp<any>

export const InternalRedirector: React.FC<RedirectorProps> = ({
    getRedirectPathFromState,
    status,
    ...props
}) => (
    <RouteStatus statusCode={status || 302}>
        <Redirect to={getRedirectPathFromState(props)} />
    </RouteStatus>
)

const mapStateToProps = (state: AppState) => state

export const Redirector = connect<AppState, {}, OwnProps, AppState>(
    mapStateToProps,
    null,
    null,
    {},
)(InternalRedirector)
